import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", id: "home" },
  { to: "/about", label: "About", id: "about" },
  { to: "/gatherings", label: "Gatherings", id: "gatherings" },
  { to: "/get-involved", label: "Get Involved", id: "get-involved" },
  { to: "/faq", label: "FAQ", id: "faq" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b"
      style={{ background: "rgba(20, 18, 16, 0.75)", borderColor: "rgba(244, 237, 217, 0.08)" }}
      data-testid="site-navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-forest-glow to-deepblue-glow flex items-center justify-center font-heading font-black text-[#141210] text-sm">
            R
          </div>
          <span className="font-heading font-black text-sm md:text-base tracking-tight uppercase">
            <span className="text-deepblue-glow">RVA</span>{" "}
            <span className="text-forest-glow">Students</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" data-testid="nav-links-desktop">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.id}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full font-heading text-[0.72rem] uppercase tracking-[0.16em] transition-all ${
                  isActive
                    ? "bg-[#F4EDD9] text-[#141210]"
                    : "text-white/60 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/gatherings" className="hidden md:inline-flex btn-primary" data-testid="nav-cta-button">
            Next Gathering
          </Link>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-full border border-white/15"
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t" style={{ background: "#141210", borderColor: "rgba(244,237,217,0.08)" }} data-testid="nav-mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.id}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-2xl font-heading text-sm uppercase tracking-[0.14em] ${
                    isActive ? "bg-[#F4EDD9] text-[#141210]" : "text-white/70 hover:bg-white/5"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
